import { Component, HostBinding, Inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { AppWindow } from '../../AppWindow';
import { AuthorizationService } from '../../authorization/authorization.service';
import { EnterpriseConfigurationDataAccessService } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  public contactSalesAnchorText: string | undefined;
  public contactSalesAnchorUrl: SafeUrl | undefined;
  public contactSalesRouterLink: string | undefined;
  public contactSupportAnchorText: string | undefined;
  public contactSupportAnchorUrl: SafeUrl | undefined;
  public contactSupportRouterLink: string | undefined;
  public siteName: string | undefined;
  @HostBinding('class.home-component') public hostElementClass: string = 'home-component';
  private _hideSubheading$ = new ReplaySubject<boolean>(1);
  public hideSubheading$: Observable<boolean> = this._hideSubheading$.asObservable();
  private _isFeatureHeroAvailable: boolean | undefined;
  private _enterpriseKey: string | undefined;
  public isMasterCardUser: boolean | undefined;
  public isAuthenticated$: Observable<boolean>;
  constructor(
    _activatedRoute: ActivatedRoute,
    private enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    sanitizer: DomSanitizer,
    @Inject('window') private _window: AppWindow,
    private _authorizationService: AuthorizationService,
  ) {
    this.isAuthenticated$ = _authorizationService.isAuthenticated$;
    enterpriseConfigurationService.getEnterpriseConfiguration().subscribe((configuration) => {
      this.siteName = configuration.siteName;
      this.isMasterCardUser = configuration.isMasterCardUser;
      this._enterpriseKey = configuration.enterpriseKey;
      if (this._enterpriseKey !== 'default') {
        this._hideSubheading$.next(true);
      }
      this.contactSalesAnchorText = configuration.contactSalesAnchorText;
      if (configuration.contactSalesAnchorUrl) {
        try {
          // We are doing this for the effect of throwing an expression when there is no protocol.
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          new URL(configuration.contactSalesAnchorUrl);
          this.contactSalesAnchorUrl = sanitizer.bypassSecurityTrustUrl(configuration.contactSalesAnchorUrl);
        } catch (e) {
          // When there is no protocol specified, an error is thrown.
        }
        if (!this.contactSalesAnchorUrl) {
          this.contactSalesRouterLink = configuration.contactSalesAnchorUrl;
        }
      }
      this.contactSupportAnchorText = configuration.contactSupportAnchorText;
      // Note that we have a different value being used for the home page than for the footer.
      if (configuration.contactSupportAnchorUrl) {
        try {
          // We are doing this for the effect of throwing an expression when there is no protocol.
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          new URL(configuration.contactSupportAnchorUrl);
          this.contactSupportAnchorUrl = sanitizer.bypassSecurityTrustUrl(configuration.contactSupportAnchorUrl);
        } catch (e) {
          // When there is no protocol specified, an error is thrown.
        }
        if (!this.contactSupportAnchorUrl) {
          this.contactSupportRouterLink = configuration.contactSupportAnchorUrl;
        }
      }
      if (
        this._window.portalConfig.featureHeroAllowedEnterprises &&
        this._window.portalConfig.featureHeroAllowedEnterprises.length === 0
      ) {
        this._isFeatureHeroAvailable = true;
      } else {
        this._isFeatureHeroAvailable = this._window.portalConfig.featureHeroAllowedEnterprises?.some(
          (enterprise) => enterprise === this._enterpriseKey,
        );
      }
    });
  }

  public get isFeatureHeroAllowed(): boolean {
    return this._isFeatureHeroAvailable ?? false;
  }

  public navigateToSignUp() {
    if (this._window.portalConfig && typeof this._window.portalConfig.signUpUrl === 'string') {
      this._window.location.href = this._window.portalConfig.signUpUrl;
    }
  }
  public navigateToContactUs() {
    this._window.location.href = 'https://www.precisely.com/contact';
  }
}
